import styled from 'styled-components';
import { BottomSns } from '../../common/BottomSnsImg';
import { SUB_TAB_STATUS } from '../../../types/type';
import { mobileQuery } from '../../../utils';
import { OnlineInfo } from './OnlineInfo';
import { OfflineInfo } from './OfflineInfo';

export const ParticipationInfo = ({
  setSubTab,
  subTab,
}: {
  setSubTab: (n: SUB_TAB_STATUS) => void;
  subTab: SUB_TAB_STATUS;
}) => {
  return (
    <>
      <Wrap>
        <TabContainer>
          <ClickTabOnline
            $isActive={subTab === SUB_TAB_STATUS.ONLINE}
            onClick={() => setSubTab(SUB_TAB_STATUS.ONLINE)}
          >
            <TabText $isActive={subTab === SUB_TAB_STATUS.ONLINE}>온라인 새틀라이트</TabText>
          </ClickTabOnline>
          <ClickTabOffline
            $isActive={subTab === SUB_TAB_STATUS.OFFLINE}
            onClick={() => setSubTab(SUB_TAB_STATUS.OFFLINE)}
          >
            <TabText $isActive={subTab === SUB_TAB_STATUS.OFFLINE}>오프라인 이벤트</TabText>
          </ClickTabOffline>
        </TabContainer>

        {subTab === SUB_TAB_STATUS.ONLINE && <OnlineInfo />}
        {subTab === SUB_TAB_STATUS.OFFLINE && <OfflineInfo />}
      </Wrap>
      <BottomSns />
    </>
  );
};

const Wrap = styled.div`
  padding-bottom: 170px;
  padding-left: 90px;
  padding-right: 90px;

  ${mobileQuery} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const Tab = styled.div`
  display: flex;
  flex: 1;
  height: 42px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  background-color: #434343;
  border: 2px solid #434343;

  ${mobileQuery} {
    height: 34px;
  }
`;
const ClickTabOnline = styled(Tab)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive
      ? 'border: 2px solid rgba(65, 192, 255, 0.13); background: linear-gradient(97deg, #FFF -31.96%, #E2E2E2 125.76%);'
      : ''}
  margin-right: 20px;

  ${mobileQuery} {
    margin-right: 12px;
  }
`;

const ClickTabOffline = styled(Tab)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive
      ? 'border: 2px solid rgba(65, 192, 255, 0.13); background: linear-gradient(97deg, #FFF -31.96%, #E2E2E2 125.76%);'
      : ''}
`;

const TabContainer = styled.div`
  display: flex;
  padding-top: 44px;
  margin-bottom: 38px;
  padding-left: 0px;
  padding-right: 0px;

  ${mobileQuery} {
    margin-bottom: 28px;
    padding-top: 15px;
    padding-left: 5px;
    padding-right: 5px;
  }
`;

const TabText = styled.h3<{ $isActive: boolean }>`
  color: ${({ $isActive }) => ($isActive ? '#000' : 'rgba(255, 255, 255, 0.50)')};

  text-align: center;
  font-size: 20px;
  line-height: 42px;
  font-weight: 600;

  ${mobileQuery} {
    font-size: 16px;
    line-height: 20px;
  }
`;
